// src/locales/en/leadAutomation.js
export const leadAutomation = {
  // Page title
  leadAutomation: 'Lead Automation',
  manageLeadForms: 'Lead Automation',
  pageDescription: 'Connect Google Sheets to automatically create orders from Meta leads',

  // Google Connect
  googleConnected: 'Google Account Connected',
  googleConnectedAs: 'Connected as',
  googleNotConnected: 'Google Account Not Connected',
  googleNotConnectedDescription: 'Connect your Google account to enable reading from Google Sheets.',
  connectGoogle: 'Connect Google Account',
  disconnectGoogle: 'Disconnect',
  disconnectConfirmTitle: 'Disconnect Google Account?',
  disconnectConfirmDescription: 'Disconnecting will stop all lead form syncs until you reconnect. Active lead forms will be paused.',
  googleConnecting: 'Connecting...',
  googleDisconnecting: 'Disconnecting...',
  googleConnectedSuccess: 'Google account connected successfully',
  googleDisconnectedSuccess: 'Google account disconnected',
  failedToConnect: 'Failed to connect Google account',
  failedToDisconnect: 'Failed to disconnect Google account',
  failedToLoadStatus: 'Failed to load Google connection status',

  // Lead Form list
  noLeadFormsYet: 'No Lead Forms Yet',
  noLeadFormsYetDescription: 'Create your first lead form to start automating order creation from your Meta leads.',
  createFirstLeadForm: 'Create Lead Form',
  createLeadForm: 'Create Lead Form',
  editLeadForm: 'Edit Lead Form',
  deleteLeadForm: 'Delete Lead Form',
  addLeadForm: 'Add Lead Form',
  failedToLoadLeadForms: 'Failed to load lead forms',

  // Lead Form card
  defaultShop: 'Default Shop',
  defaultProduct: 'Default Product',
  duplicateCheckDays: 'Duplicate Check',
  days: 'days',
  lastRow: 'Last Row',
  status: 'Status',
  statusActive: 'Active',
  statusPaused: 'Paused',
  sheetTab: 'Sheet Tab',
  uploadLeads: 'Upload Leads',
  uploading: 'Uploading...',
  uploadAllActive: 'Upload All Active',
  uploadingAll: 'Uploading All...',
  uploadAllComplete: 'Finished uploading leads for all active forms',
  viewSessions: 'View Sessions',
  resetCursor: 'Reset Cursor',
  resetCursorConfirm: 'Reset the cursor to row 1? This will re-process all rows from the beginning on the next upload.',
  cursorResetSuccess: 'Cursor reset to row 1',
  failedToResetCursor: 'Failed to reset cursor',

  // Upload result
  uploadComplete: 'Upload Complete',
  uploadFailed: 'Upload failed',
  uploadResult: {
    totalFetched: 'Rows Fetched',
    created: 'Created',
    success: 'Created',
    skipped: 'Skipped',
    duplicate: 'Duplicates',
    error: 'Errors',
  },

  // Lead Form Modal — section titles
  orderDefaults: 'Order Defaults',
  noNewRows: 'No new rows found in the sheet',
  showErrors: 'Show Errors',
  hideErrors: 'Hide Errors',
  rowLabel: 'Row',
  alreadyUploading: 'An upload is already in progress for this form',
  googleNotConnectedError: 'Please connect your Google account first',

  // Lead Form Modal — basic info
  formName: 'Form Name',
  formNamePlaceholder: 'e.g., Facebook Leads - July',
  googleSheetId: 'Google Sheet ID',
  googleSheetIdPlaceholder: 'Paste the Google Sheet ID or URL',
  googleSheetIdHint: 'Find it in the sheet URL: docs.google.com/spreadsheets/d/<ID>/edit',
  sheetTabName: 'Sheet Tab Name',
  sheetTabNamePlaceholder: 'e.g., Sheet1',
  selectShop: 'Select Default Shop',
  selectProduct: 'Select Default Product',
  selectVariation: 'Select Variation (optional)',
  defaultQuantity: 'Default Quantity',
  duplicateCheckDaysLabel: 'Duplicate Check Days',
  duplicateCheckDaysHint: 'Skip leads where same phone placed an order within this many days',
  startFromRow: 'Start from Row',
  startFromRowHint: 'Rows before this number will be skipped. Use this to avoid re-uploading leads already entered manually.',
  useCityUnknown: 'Use "City Unknown" when city is not found',
  pauseForm: 'Pause this form',

  // Field mapping section
  fieldMapping: 'Field Mapping',
  fieldMappingDescription: 'Map your sheet column headers to the order fields below.',
  loadColumns: 'Load Sheet Columns',
  loadingColumns: 'Loading columns...',
  columnsLoaded: 'columns loaded',
  failedToLoadColumns: 'Failed to load sheet columns',
  enterSheetIdAndTabFirst: 'Enter the Sheet ID and Tab Name first, then load columns.',
  canonicalFields: {
    Customer_Name: 'Customer Name',
    Address: 'Address',
    City_Name: 'City',
    Phone_1: 'Phone 1 (primary)',
    Phone_2: 'Phone 2 (optional)',
    Customer_Email: 'Email (optional)',
    Private_Reference: 'Private Reference (optional)',
    Delivery_Notes: 'Delivery Notes (optional)',
    Item_1_Quantity: 'Item Quantity (overrides default)',
  },
  selectColumn: 'Select column',
  noMapping: '— Not mapped —',

  // Session history
  sessionHistory: 'Upload Session History',
  backToLeadForms: 'Back to Lead Forms',
  noSessionsYet: 'No uploads yet',
  noSessionsYetDescription: 'Session records will appear here after each upload.',
  session: {
    date: 'Date',
    rows: 'Rows',
    created: 'Created',
    skipped: 'Skipped',
    duplicates: 'Duplicates',
    errors: 'Errors',
    status: 'Status',
    statusSuccess: 'Success',
    statusPartial: 'Partial',
    statusFailed: 'Failed',
    triggeredBy: 'By',
    rowRange: 'Row Range',
    statusCompleted: 'Completed',
  },

  // Validation
  validation: {
    nameRequired: 'Form name is required',
    sheetIdRequired: 'Google Sheet ID is required',
    tabNameRequired: 'Sheet tab name is required',
    shopRequired: 'Default shop is required',
    productRequired: 'Default product is required',
    quantityMin: 'Quantity must be at least 1',
    duplicateCheckDaysMin: 'Must be at least 1',
    duplicateCheckDaysMax: 'Cannot exceed 365 days',
    fixErrors: 'Please fix the errors in the form',
  },

  // Actions
  save: 'Save',
  saving: 'Saving...',
  cancel: 'Cancel',
  delete: 'Delete',
  confirm: 'Confirm',
  confirmDelete: 'Are you sure you want to delete this lead form?',
  confirmDeleteDescription: 'All session history will also be deleted. This action cannot be undone.',
  leadFormCreated: 'Lead form created successfully',
  leadFormUpdated: 'Lead form updated successfully',
  leadFormDeleted: 'Lead form deleted successfully',
  failedToCreate: 'Failed to create lead form',
  failedToUpdate: 'Failed to update lead form',
  failedToDelete: 'Failed to delete lead form',
  failedToUpload: 'Upload failed',
  failedToLoadSessions: 'Failed to load session history',
};
